var _this = this;
var handler = {
  get: function get(target, name) {
    return target.hasOwnProperty(name) ? target[name] : function () {
      var _window;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_window = window).__tap.apply(_window, [name].concat(args));
    };
  }
};
var target = {
  init: function init(accountId) {
    var createOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      integration: "npm-module"
    };
    var createCallback = arguments.length > 2 ? arguments[2] : undefined;
    var detectOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var detectCallback = arguments.length > 4 ? arguments[4] : undefined;
    if (window.__tap) return;
    (function (t, a, p) {
      t.TapfiliateObject = a;
      t[a] = t[a] || function () {
        (t[a].q = t[a].q || []).push(arguments);
      };
    })(window, "__tap");
    var script = document.createElement("script");
    script.src = "https://script.tapfiliate.com/tapfiliate.js";
    script.type = "text/javascript";
    script.async = true;
    document.getElementsByTagName("head")[0].appendChild(script);
    script.addEventListener("error", function () {
      new Error("".concat(_this.src, " failed to load."));
    });
    window.__tap("create", accountId, createOptions, createCallback);
    window.__tap("detect", detectOptions, detectCallback);
  }
};
var Tap = new Proxy(target, handler);
export default Tap;